import Vue from 'vue'
import VueRouter from 'vue-router'
import { STORAGE_CWID } from '@/config/display/storage.config'
import { STORAGE_CONFERENCE_CWID } from '@/config/conference/storage.config'

Vue.use(VueRouter)

const routes = [
  {
    path: '/display',
    name: 'displayAuth',
    component: () => import('@/views/display/Auth'),
    meta: {
      title: '认证中...',
    },
  },
  {
    path: '/display/list',
    name: 'displayList',
    component: () => import('@/views/display/Index'),
    meta: {
      title: '陈列服务检查',
    },
  },
  {
    path: '/display/check',
    name: 'displayCheck',
    component: () => import('@/views/display/ServiceCheck'),
    meta: {
      title: '陈列服务检查',
    },
  },
  {
    path: '/display/result',
    name: 'displayResult',
    component: () => import('@/views/display/CheckResult'),
    meta: {
      title: '陈列检查明细',
    },
  },

  // 学术会议相关路由
  {
    path: '/conference',
    name: 'conferenceAuth',
    component: () => import('@/views/conference/Auth'),
    meta: {
      title: '认证中...',
    },
  },
  {
    path: '/conference/list',
    name: 'conferenceIndex',
    component: () => import('@/views/conference/Index'),
    meta: {
      title: '学术会议检查',
      keepAlive: true,
    },
  },
  {
    path: '/conference/check',
    name: 'conferenceServiceCheck',
    component: () => import('@/views/conference/ServiceCheck'),
    meta: {
      title: '学术会议检查拍照',
    },
  },
  {
    path: '/conference/result',
    name: 'conferenceCheckResult',
    component: () => import('@/views/conference/CheckResult'),
    meta: {
      title: '学术会议检查明细',
    },
  },
  {
    path: '/conference/reshoot',
    name: 'conferenceReshoot',
    component: () => import('@/views/conference/SignInReshoot'),
    meta: {
      title: '学术会议签到表补拍',
    },
  },
  {
    path: '/error',
    name: 'error',
    component: () => import('@/views/Error'),
    meta: {
      title: '出错了',
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
})

const routerNameList = routes.map(r => r.name)

// 路由拦截器
router.beforeEach((to, from, next) => {
  // 如果不是去认证页，则检查是否存在cwid
  if (to.name && routerNameList.includes(to.name) === -1) {
    next({ name: 'error', query: to.query })
    return
  }
  
  console.log('Router - beforeEach - ', { to, from })
  if (to.name && to.name.indexOf('conference') > -1) {
    if (to.name !== 'conferenceAuth' && !localStorage.getItem(STORAGE_CONFERENCE_CWID)) {
      next({ name: 'conferenceAuth', query: to.query })
      return
    }
  } else if (to.name && to.name.indexOf('display') > -1) {
    if (to.name !== 'displayAuth' && !localStorage.getItem(STORAGE_CWID)) {
      next({ name: 'displayAuth', query: to.query })
      return
    }
  } else if (to.name !== 'error') {
    // 非法路由，跳转错误页
    next({ name: 'error', query: to.query })
    return
  }
  // 根据路由设置 title
  if (to.meta.title) document.title = to.meta.title
  next()
})

export default router
